import type { WinnerRevealedDto } from '@shared/types';
import { Confetti } from '@shared/Confetti';
import { initials, titleCase } from '@shared/format';

export function WinnerScreen({ winner }: { winner: WinnerRevealedDto }) {
  return (
    <div className="screen screen-winner">
      <div className="rays" aria-hidden="true" />
      <Confetti />
      <div className="winner-content">
        <img src="./brand/kes-logo-reversed.png" alt="Keystone Energy Services" className="winner-logo" />
        <h1 className="congrats">CONGRATULATIONS!</h1>
        <div className="winner-badge" aria-hidden="true">{initials(winner.winnerName)}</div>
        <div className="winner-name">{winner.winnerName}</div>
        <div className="winner-type">{titleCase(winner.drawingType)} Winner</div>
        <div className="winner-program">Safety Accountability Program</div>
        <div className="winner-prize">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 11h16v10H4zM3 7h18v4H3zM12 7v14M12 7c-2-4-6-4-6-1s4 1 6 1c2 0 6 2 6-1s-4-3-6 1" fill="none" stroke="currentColor" strokeWidth="1.8" /></svg>
          {winner.prizeName}
        </div>
      </div>
    </div>
  );
}
